import PropTypes from "prop-types";
import React from "react";
import DiscoPoweredCarousel from "components/source/shared/carousels/DiscoPoweredCarousel";

export default function Carousel({ title, subtitle, href, products }) {
  return (
    <div className="mb-10">
      <div className="flex justify-between items-center mb-3 lg:mb-4">
        <h3 className="ml-3 mb-0 text-xl lg:text-h3 lg:ml-20">{title}</h3>
        <a className="mr-3 lg:mr-10 font-medium underline" href={href}>
          {subtitle}
        </a>
      </div>
      <DiscoPoweredCarousel products={products} />
    </div>
  );
}

Carousel.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  href: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.object),
};
